<script setup lang="ts">
import type { DefaultSlotProps } from "@/types";
import type { ToggleSwitchSlots } from "primevue/toggleswitch";

import ToggleSwitch from "primevue/toggleswitch";
import { computed, useAttrs, useId } from "vue";

defineSlots<ToggleSwitchSlots & DefaultSlotProps>();

const attrs = useAttrs();

const mergedPt = computed(() => ({
  slider: { class: "!rounded-md" },
  ...(attrs.pt as Record<string, unknown> | undefined),
}));

const forwardAttrs = computed(() => {
  // oxlint-disable-next-line typescript/no-unused-vars
  const { pt: _pt, ...rest } = attrs;
  return rest;
});
</script>

<template>
  <ToggleSwitch :id="`input-switch-${useId()}`" v-bind="forwardAttrs" :pt="mergedPt">
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </ToggleSwitch>
</template>

<style lang="postcss" scoped></style>
